import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSignUp, setIsSignUp] = useState(false);
    const [isResetPassword, setIsResetPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    
    const { login, signup, resetPassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setMessage(null);
        
        try {
            if (isResetPassword) {
                await resetPassword(email);
                setMessage('Password reset link sent to your email');
                setIsResetPassword(false);
            } else if (isSignUp) {
                await signup(email, password);
                setMessage('Sign up successful! Check your email for verification link.');
            } else {
                await login(email, password);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const renderForm = () => {
        if (isResetPassword) {
            return (
                <>
                    <h2>Reset Password</h2>
                    <p>Enter your email address and we'll send you a link to reset your password.</p>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    
                    <button
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                    
                    <p className="toggle-auth">
                        <button
                            type="button"
                            className="toggle-auth-button"
                            onClick={() => setIsResetPassword(false)}
                        >
                            Back to Login
                        </button>
                    </p>
                </>
            );
        }
        
        return (
            <>
                <h2>{isSignUp ? 'Create Account' : 'Log In'}</h2>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                
                {!isSignUp && (
                    <p className="forgot-password">
                        <button
                            type="button"
                            className="forgot-password-button"
                            onClick={() => setIsResetPassword(true)}
                        >
                            Forgot password?
                        </button>
                    </p>
                )}
                
                <button
                    type="submit"
                    className="login-button"
                    disabled={loading}
                >
                    {loading ? 'Processing...' : isSignUp ? 'Sign Up' : 'Log In'}
                </button>
                
                <p className="toggle-auth">
                    {isSignUp ? 'Already have an account?' : 'Need an account?'}{' '}
                    <button
                        type="button"
                        className="toggle-auth-button"
                        onClick={() => setIsSignUp(!isSignUp)}
                    >
                        {isSignUp ? 'Log In' : 'Sign Up'}
                    </button>
                </p>
            </>
        );
    };

    return (
        <div className="login-container">
            <div className="login-content">
                <h1>Rugby Match Tracking</h1>
                
                {error && <div className="error-message">{error}</div>}
                {message && <div className="success-message">{message}</div>}
                
                <form onSubmit={handleSubmit}>
                    {renderForm()}
                </form>
            </div>
        </div>
    );
};

export default LoginPage;